"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.join = exports.getHeader = exports.constructHeaders = void 0;
const constructHeaders = (collectors) => {
    return async () => {
        let headers = {};
        for (let collector of collectors) {
            if (!collector) {
                continue;
            }
            if (typeof collector === 'function') {
                headers = {
                    ...headers,
                    ...((await collector()) || {})
                };
            }
            else {
                headers = {
                    ...headers,
                    ...collector
                };
            }
        }
        return headers;
    };
};
exports.constructHeaders = constructHeaders;
/**
 * A small utility to get a key from a map in a case-insensitive way
 */
const getHeader = (headers, key) => {
    return Object.fromEntries(Object.entries(headers).map(([key, value]) => {
        return [key.toLowerCase(), value];
    }))[key.toLowerCase()];
};
exports.getHeader = getHeader;
/**
 * A weak clone of path.join from node that will work in the browser too. Joins all given
 * strings together with a '/' and then strips off duplicates.
 *
 * ["https://a/b/c/", "/d/e//f/"] => "https://a/b/c///d/e//f/" => "https://a/b/c/d/e/f/"
 */
const join = (...parts) => {
    const components = parts.join('/').split(/:\/\//);
    const deduped = (components[1] || components[0]).replace(/\/\/+/g, '/');
    if (components[1]) {
        return [components[0], deduped].join('://');
    }
    return deduped;
};
exports.join = join;
